module.exports = __webpack_public_path__ + "img/04-pic-L.dff85b9b.png";